const topicItems = [
  { id: 1, label: '斗罗大陆', count: '89.2万讨论', hot: true },
  { id: 2, label: '国漫崛起', count: '56.7万讨论', hot: true },
  { id: 3, label: '下拉式阅读', count: '34.1万讨论', hot: false },
  { id: 4, label: '日漫新番', count: '72.3万讨论', hot: true },
  { id: 5, label: '韩漫推荐', count: '45.8万讨论', hot: false },
  { id: 6, label: '修仙漫画', count: '61.4万讨论', hot: true },
  { id: 7, label: '完结神作', count: '28.9万讨论', hot: false },
  { id: 8, label: '漫画免费', count: '93.5万讨论', hot: true },
  { id: 9, label: '完美世界', count: '52.1万讨论', hot: false },
  { id: 10, label: '我独自升级', count: '67.3万讨论', hot: true },
  { id: 11, label: '凡人修仙传', count: '48.6万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            加入漫画爱好者社区，参与最热门的话题讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group relative inline-flex items-center gap-2 px-5 py-3 rounded-xl border cursor-pointer transition-all ${
                item.hot
                  ? 'bg-primary-50/50 border-primary-200 hover:bg-primary-100/60 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/70 hover:bg-background-100 hover:border-background-300'
              }`}
            >
              {item.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-primary-500 rounded-full flex items-center justify-center">
                  <i className="ri-fire-fill text-[8px] text-background-50"></i>
                </span>
              )}
              <span className="font-heading text-sm text-foreground-800 whitespace-nowrap">#{item.label}</span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}